export default __webpack_public_path__ + "static/media/down-up-down.1e65ddcd.svg";